import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { normalizeLocale, SUPPORTED_LOCALES, DEFAULT_LOCALE, type Locale } from '@etap/shared';
import { ru } from './locales/ru';
import { en } from './locales/en';
import { kk } from './locales/kk';

const STORAGE_KEY = 'etap_webapp_locale';

function detectInitialLocale(): Locale {
  if (typeof window === 'undefined') return DEFAULT_LOCALE;
  try {
    const stored = window.localStorage?.getItem(STORAGE_KEY);
    if (stored && (SUPPORTED_LOCALES as readonly string[]).includes(stored)) {
      return stored as Locale;
    }
  } catch {
    /* ignore */
  }
  const tg = window.Telegram?.WebApp?.initDataUnsafe?.user?.language_code;
  if (tg) return normalizeLocale(tg);
  const fromNav = typeof navigator !== 'undefined' ? navigator.language : '';
  return normalizeLocale(fromNav);
}

void i18n.use(initReactI18next).init({
  resources: {
    ru: { translation: ru },
    en: { translation: en },
    kk: { translation: kk },
  },
  lng: detectInitialLocale(),
  fallbackLng: DEFAULT_LOCALE,
  interpolation: { escapeValue: false },
});

export function getStoredLocale(): Locale {
  return detectInitialLocale();
}

export function setLocale(locale: Locale) {
  void i18n.changeLanguage(locale);
  try {
    window.localStorage?.setItem(STORAGE_KEY, locale);
  } catch {
    /* ignore */
  }
  try {
    document.documentElement.lang = locale;
  } catch {
    /* ignore */
  }
}

export { i18n };
export type { Locale };
